module.exports = __webpack_public_path__ + "img/payment-skrill.f2c8fb08.svg";